import { Validate } from '@edgvr-front/util/validate';
import { binaryEntityRaw } from '../schema';
import { BinaryEntityRaw } from '../interface';

export class BinaryEntity {
  private static validation = Validate.compile(binaryEntityRaw);

  constructor(readonly value: BinaryEntityRaw) {
    Validate.assert(BinaryEntity.validation, value);
  }
}
